import { render, staticRenderFns } from "./CompanyCard.vue?vue&type=template&id=2ca19740&scoped=true"
import script from "./CompanyCard.vue?vue&type=script&lang=js"
export * from "./CompanyCard.vue?vue&type=script&lang=js"
import style0 from "./CompanyCard.vue?vue&type=style&index=0&id=2ca19740&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ca19740",
  null
  
)

export default component.exports